(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jdt-lbt-zy"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function(){
  const wrap = document.querySelector('.sync-carousel-wrap');
  const autoSec = Number(wrap.dataset.autoplaySecond) || 6;
  const totalMs = autoSec * 1000;

  const imgWrap = document.querySelector('.img-wrap');
  const cards = document.querySelector('.cards');
  const originSlides = Array.from(document.querySelectorAll('.img-slide'));
  const textEls = document.querySelectorAll('.list-info');
  const originTotal = originSlides.length;
  if (originTotal < 2) return;

  let slideStep = 0;
  let current = 1;
  let isAnimating = false;
  let autoTimer = null;
  let tick = 0;
  const tickStep = 50;

  // 拖拽/触屏变量
  let drag = {
    isDragging: false,
    startX: 0,
    moveX: 0
  };
  const dragThreshold = () => slideStep * 0.2;

  const progressCircle = document.querySelector('.progress-fill');
  const radius = 24.5;
  const circumference = 2 * Math.PI * radius;
  progressCircle.setAttribute('stroke-dasharray', circumference);

  // 首尾克隆 稳定无缝
  function cloneSlides() {
    const first = originSlides[0].cloneNode(true);
    const last = originSlides[originTotal - 1].cloneNode(true);
    imgWrap.prepend(last);
    imgWrap.append(first);
  }

  // 计算宽度
  function calcWidth() {
    const slide = imgWrap.querySelector('.img-slide');
    const gap = parseFloat(getComputedStyle(imgWrap).gap);
    slideStep = slide.offsetWidth + gap;
  }

  // 同步文字+遮罩
  function updateView() {
    let real = current - 1;
    if (real < 0) real = originTotal - 1;
    if (real >= originTotal) real = 0;
    
    textEls.forEach(el => el.classList.remove('active'));
    textEls[real].classList.add('active');

    const all = imgWrap.querySelectorAll('.mask-layer');
    all.forEach(m => m.style.opacity = 0);
    const next = (real + 1) % originTotal;
    originSlides[next].querySelector('.mask-layer').style.opacity = 1;
  }

  function render() {
    imgWrap.style.transition = 'transform 0.6s ease';
    imgWrap.style.transform = `translateX(${-current * slideStep}px)`;
    updateView();
  }

  // 核心无缝复位
  function resetPosition() {
    imgWrap.style.transition = 'none';
    if (current === 0) current = originTotal;
    if (current === originTotal + 1) current = 1;
    imgWrap.style.transform = `translateX(${-current * slideStep}px)`;
    isAnimating = false;
    // 修复：复位后重新启动自动轮播
    startAuto();
  }

  function resetProgress() {
    tick = 0;
    progressCircle.style.transition = 'none';
    progressCircle.setAttribute('stroke-dashoffset', circumference);
    progressCircle.getBoundingClientRect();
    progressCircle.style.transition = '';
  }

  // 重构自动轮播函数（确保重复调用不冲突）
  function startAuto() {
    // 先清除旧定时器，再创建新的
    if (autoTimer) clearInterval(autoTimer);
    resetProgress();
    autoTimer = setInterval(() => {
      tick += tickStep;
      const per = tick / totalMs;
      progressCircle.setAttribute('stroke-dashoffset', circumference * (1 - per));
      if (tick >= totalMs && !isAnimating) {
        next();
      }
    }, tickStep);
  }

  // 左滑 1→3→2→1
  function prev() {
    if (isAnimating) return;
    isAnimating = true;
    current--;
    render();
    setTimeout(resetPosition, 600);
  }

  // 右滑 1→2→3→1
  function next() {
    if (isAnimating) return;
    isAnimating = true;
    current++;
    render();
    setTimeout(resetPosition, 600);
  }

  // ========== 鼠标拖拽 + 触屏滑动逻辑（修复拖拽后不轮播） ==========
  function dragStart(clientX) {
    if (isAnimating) return;
    drag.isDragging = true;
    drag.startX = clientX;
    drag.moveX = 0;
    // 拖拽时暂停自动轮播
    if (autoTimer) clearInterval(autoTimer);
    imgWrap.style.transition = 'none';
  }
  function dragMove(clientX) {
    if (!drag.isDragging) return;
    drag.moveX = clientX - drag.startX;
    imgWrap.style.transform = `translateX(${-current * slideStep + drag.moveX}px)`;
  }
  function dragEnd() {
    if (!drag.isDragging) return;
    drag.isDragging = false;
    imgWrap.style.transition = 'transform 0.6s ease';
    
    if (drag.moveX > dragThreshold()) {
      prev(); // 左滑 → 调用prev后，resetPosition会重启自动轮播
    } else if (drag.moveX < -dragThreshold()) {
      next(); // 右滑 → 调用next后，resetPosition会重启自动轮播
    } else {
      // 拖拽距离不足，复位后直接重启自动轮播
      render();
      startAuto();
    }
  }

  // PC鼠标拖拽
  cards.addEventListener('mousedown', (e) => dragStart(e.clientX));
  document.addEventListener('mousemove', (e) => dragMove(e.clientX));
  document.addEventListener('mouseup', dragEnd);
  document.addEventListener('mouseleave', dragEnd);

  // 移动端触屏滑动
  cards.addEventListener('touchstart', (e) => {
    dragStart(e.touches[0].clientX);
  }, { passive: true });
  cards.addEventListener('touchmove', (e) => {
    dragMove(e.touches[0].clientX);
  }, { passive: true });
  cards.addEventListener('touchend', dragEnd);
  cards.addEventListener('touchcancel', dragEnd);

  // 初始化
  cloneSlides();
  calcWidth();
  render();
  startAuto();

  // 按钮点击（点击后自动重启轮播）
  document.querySelector('.prev-btn').onclick = prev;
  document.querySelector('.next-btn').onclick = next;

  // 缩放适配（缩放后重启轮播）
  window.addEventListener('resize', () => {
    if (autoTimer) clearInterval(autoTimer);
    calcWidth();
    render();
    startAuto();
  });
});

  } catch(e) { console.error(e); }
})();
})();
